import { DeleteVariantIcon } from './DeleteVariantIcon';

/**
 * author: Austin Andrews
 * id DC3862AC-6945-4104-9F15-50BD46D13705
 * name delete-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/delete-variant.svg
 * tags
 */
export const DrinkIceIcon = DeleteVariantIcon;
export default DrinkIceIcon